import ExpressColorManager from './express-color-manager'
import { PickColor } from './base-color-manager'

export default ExpressColorManager
export { PickColor }
